import { PersonVm } from './PersonVm'
import { StatusVm } from "./StatusVm";

export class DriverCardVm {
    Id: number = 0;
    CardDataId: number = 0;
    CardNumber: string = "";
    Person: PersonVm = new PersonVm();
    ValidFrom: Date | null = null;
    ValidTo: Date | null = null;
    Status: StatusVm = new StatusVm();
    Remark: string = "";
    IssuingCountry: string = "";
    CreatedDate: Date | null = null;
}